<template>
<div>
<div class="toppurple ios">
    <div class="invitetut">شیوه دعوت مدعوین</div>
    <div class="and-ios-tabs farsi">
        <div class="ios">آی او اس</div>
        <div class="android">اندروید</div>
    </div>
</div>
<div class="tutorial-container">

    <div class="tutorial-steps" style="margin-top:40px;">
       
    </div>
    <div class="ios-tab">
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۱/۶</div>
        <div class="tutorial-desc">از پنل مدعوین بر روی افزودن شناسه کلیک کنید.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosinvite1.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۲/۶</div>
        <div class="tutorial-desc">۱-شناسه‌ی دلخواه خود را بسازید.
            <br>
            ۲- بر روی ذخیره تغییرات کلیک کنید.
        </div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosinvite2.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۳/۶</div>
        <div class="tutorial-desc">آیکون دعوت دوستان با این شناسه را انتخاب کنید.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosinvite3.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۴/۶</div>
        <div class="tutorial-desc">از هر راهی که تمایل دارید برای ارسال دعوت‌نامه اقدام کنید.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosinvite4.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۵/۶</div>
        <div class="tutorial-desc">لینک دعوت‌نامه و شناسه‌ی شمابه همراه پیام فرستاده میشه.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosinvite5.png" alt="ios tutorial"></div>
    </div> 
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۶/۶</div>
        <div class="tutorial-desc">برای حذف، کافیه شناسه‌ی مورد نظر را به چپ بکششید.</div>
        <div class="tutorial-pic"><img src="/images/tutorials/iosinvite6.png" alt="ios tutorial"></div>
    </div> 
    </div>
    <div class="android-tab">
    <div class="tutorial-steps">
        <div class="tutorial-level">مرحله ۱/۱۳</div>
        <div class="tutorial-desc">آیکون منو را لمس کنید</div>
        <div class="tutorial-pic"><img src="/images/tutorials/group.png" alt="ios tutorial"></div>
    </div> 
        <div class="tutorial-steps">
            <div class="tutorial-level">مرحله ۲/۱۳</div>
            <div class="tutorial-desc">مدعوین را انتخاب کنید.
            </div>
            <div class="tutorial-pic"><img src="/images/tutorials/group 2.png" alt="ios tutorial"></div>
        </div> 
        <div class="tutorial-steps">
            <div class="tutorial-level">مرحله ۳/۱۳</div>
            <div class="tutorial-desc">بر روی دکمه افزون شناسه‌ی جدید کلیک کنید.</div>
            <div class="tutorial-pic"><img src="/images/tutorials/group 3.png" alt="ios tutorial"></div>
        </div> 
        <div class="tutorial-steps">
            <div class="tutorial-level">مرحله ۴/۱۳</div>
            <div class="tutorial-desc">شناسه‌ی دلخواه خود را بسازید.</div>
            <div class="tutorial-pic"><img src="/images/tutorials/group 4.png" alt="ios tutorial"></div>
        </div> 
        <div class="tutorial-steps">
            <div class="tutorial-level">مرحله ۵/۱۳</div>
            <div class="tutorial-desc">شناسه‌ی شما ساخته شد.</div>
            <div class="tutorial-pic"><img src="/images/tutorials/group 5.png" alt="ios tutorial"></div>
        </div> 
        <div class="tutorial-steps">
            <div class="tutorial-level">مرحله ۶/۱۳</div>
            <div class="tutorial-desc">برای دعوت دوباره به منوی اصلی برگردید و بر روی دعوت دوستان کلیک کنید.</div>
            <div class="tutorial-pic"><img src="/images/tutorials/group 5-1.png" alt="ios tutorial"></div>
        </div> 
        <div class="tutorial-steps">
            <div class="tutorial-level">مرحله ۷/۱۳</div>
            <div class="tutorial-desc">یکی از شناسه ها را انتخاب کنید.</div>
            <div class="tutorial-pic"><img src="/images/tutorials/group 6.png" alt="ios tutorial"></div>
        </div> 
            <div class="tutorial-steps">
                <div class="tutorial-level">مرحله ۸/۱۳</div>
                <div class="tutorial-desc">از هر راهی که تمایل دارید برای ارسال دعوت نامه اقدام کنید.
                </div>
                <div class="tutorial-pic"><img src="/images/tutorials/group 7.png" alt="ios tutorial"></div>
            </div> 
            <div class="tutorial-steps">
                <div class="tutorial-level">مرحله ۹/۱۳</div>
                <div class="tutorial-desc">برای دوستان خود ارسال کنید.</div>
                <div class="tutorial-pic"><img src="/images/tutorials/group 8.png" alt="ios tutorial"></div>
            </div> 
            <div class="tutorial-steps">
                <div class="tutorial-level">مرحله ۱۰/۱۳</div>
                <div class="tutorial-desc">برای مدیریت شناسه‌ها دکمه‌ مدیریت شناسه‌ها را در انتهای منوی مدعوین را انتخاب کنید.</div>
                <div class="tutorial-pic"><img src="/images/tutorials/group 9.png" alt="ios tutorial"></div>
            </div> 
            <div class="tutorial-steps">
                <div class="tutorial-level">مرحله ۱۱/۱۳</div>
                <div class="tutorial-desc">شناسه مورد نظر خود را انتخاب کنید.</div>
                <div class="tutorial-pic"><img src="/images/tutorials/group 10.png" alt="ios tutorial"></div>
            </div> 
            <div class="tutorial-steps">
                <div class="tutorial-level">مرحله۱۲/۱۳</div>
                <div class="tutorial-desc">برای حذف بر روی حذف شناسه کلیک کنید.</div>
                <div class="tutorial-pic"><img src="/images/tutorials/group 11.png" alt="ios tutorial"></div>
            </div> 
            <div class="tutorial-steps">
                <div class="tutorial-level">مرحله۱۳/۱۳</div>
                <div class="tutorial-desc">حذف شناسه را کلیک کنید. با این کار امام مدعوین به شماره همراه شما برمیگردند.</div>
                <div class="tutorial-pic"><img src="/images/tutorials/group 12.png" alt="ios tutorial"></div>
            </div> 
    </div>        
</div>
</div>
</template>

<script>

export default {
    data(){
        return{       
        }
    },
    components: {

    },
    methods: {
        
    },
    mounted(){
        this.$store.state.loading=false
         
    }
}
</script>

<style>
 
</style>
